<template>
  <body class="cursor-pointer overflow-hidden">
    <div class="space-y-12">
      <div
        v-for="post in posts"
        :key="post.id"
        :currentPostId="post.id"
        @click="postDetails(post.id)"
        class="border-2 border-zinc-300 rounded-2xl w-full px-4 py-4 hover:shadow-lg duration-300 flex flex-col justify-start items-start"
      >
        <div>
          <h1 class="text-lg font-bold flex justify-start">
            {{ post.title }}
          </h1>
        </div>
        <div class="text-left">
          <tagsNew :searchTags="post.tags" />
        </div>
        <p class="flex justify-start text-left text-sm">
          {{ post.subtitle }}
        </p>
      </div>
      <div class="text-center" v-if="isLoading">
        <div role="status">
          <svg
            class="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-400 fill-custom-blue"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import axios from "axios";
import tagsNew from "../components/tagsNew.vue";

export default {
  components: {
    tagsNew,
  },
  data() {
    return {
      title: "",
      posts: this.posts,
      post: "",
      scrolledDown: false,
      isLoading: false,
    };
  },

  mounted() {
    this.lazyLoadPosts();
  },

  methods: {
    lazyLoadPosts() {
      if (!this.scrolledDown) {
        this.getPosts();
      }
      //lazy load posts
      //if user scrolls down show the rest of posts
      window.addEventListener("scroll", () => {
        const { scrollTop, scrollHeight, clientHeight } =
          document.documentElement;
        if (clientHeight + scrollTop >= scrollHeight - 500) {
          this.scrolledDown = true;

          this.getPosts();
        }
      });
    },

    async getPosts() {
      axios
        .get(
          "https://7c7562ad-7bd2-4ed6-9934-sabahincubation-f00b0914dc16q72.com/all_posts/"
        )
        .then((response) => {
          this.posts = response.data;
          // lazy load posts
          if (!this.scrolledDown) {
            this.posts = this.posts.slice(0, 10);
          } else if (this.scrolledDown) {
            this.isLoading = false;
            this.posts = this.posts.slice(0, 50);
          }

          // if all posts are fetched then stop loading
          if (this.posts.length === response.data.length) {
            this.isLoading = false;
          }

          if (this.posts.length === response.data.length) {
            this.isLoading = false;
          } else if (this.posts.length > 0) {
            this.isLoading = true;
          }

          for (let i = 0; i < this.posts.length; i++) {
            //show post id
            this.posts[i].tags = this.posts[i].tags.split(",");
            this.newTags = this.posts[i].tags;
          }

          console.log(this.newTags);
        });
    },

    async postDetails(postId) {
      axios
        .get(
          "https://7c7562ad-7bd2-4ed6-9934-sabahincubation-f00b0914dc16q72.com/post/" +
            postId +
            "/"
        )
        .then((response) => {
          this.post = response.data;
          console.log(this.post.category);
          if (this.post.category == "Books") {
            this.$router.push("/bookDetails/" + postId);
          } else if (this.post.category == "Articles") {
            this.$router.push("/postdetails/" + postId);
          } else if (this.post.category == "Videos") {
            this.$router.push("/videodetails/" + postId);
          }
        });
    },
  },
};
</script>

<style></style>
